import { atom } from "recoil"

export const navigationAtom = atom({
    key: "navigationAtom",
    default: "Home"
})

export const shouldRedirectToLoginAtom = atom({
    key: "shouldRedirectToLoginAtom",
    default: false
})